// InsightStrip — the context panel shown BEFORE a CRUD table.
// Gives the user business understanding before raw data (the "page philosophy").
// Each chip is a computed metric for the resource (e.g. "22 products · $4,200 inventory · 3 low").

import { Chip, Stack } from '@mui/material';
import { UI } from '../../brand/ui';

export type InsightChip = {
  label: string;
  value: string | number;
  tone?: 'default' | 'success' | 'warning' | 'error';
};

export function InsightStrip({ chips, loading }: { chips: InsightChip[]; loading?: boolean }) {
  if (loading || !chips.length) return null;
  return (
    <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: 'wrap', gap: 1 }}>
      {chips.map((chip, i) => (
        <Chip
          key={i}
          size="small"
          label={`${chip.label}: ${chip.value}`}
          color={chip.tone === 'success' ? 'success' : chip.tone === 'warning' ? 'warning' : chip.tone === 'error' ? 'error' : 'default'}
          variant={chip.tone && chip.tone !== 'default' ? 'filled' : 'outlined'}
          sx={{
            fontWeight: 700,
            bgcolor: chip.tone && chip.tone !== 'default' ? undefined : 'rgba(255,255,255,0.72)',
            borderColor: chip.tone && chip.tone !== 'default' ? undefined : UI.accentAlpha(0.16),
            boxShadow: chip.tone && chip.tone !== 'default' ? undefined : UI.shadowSm
          }}
        />
      ))}
    </Stack>
  );
}
